import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Tag>
  );
};

export const SectionHeading = ({ eyebrow, title, intro, id, light = false, className = "" }) => (
  <div className={`max-w-2xl ${className}`}>
    <Reveal>
      <p className={`eyebrow ${light ? "text-gold" : ""}`}>{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 id={id} className={`mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05] ${light ? "text-cream" : "text-navy"}`}>
        {title}
      </h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-cream/80" : "text-navy/75"}`}>{intro}</p>
      </Reveal>
    )}
  </div>
);
